import { useMutation } from "lib/apollo/client";
import { updateProgress } from "queries/goals/updateProgress";
import Button from "hardcover-ui/components/Button";
import { router } from "@inertiajs/react";
import { GoalSerializersGoalByline } from "types/serializers";

export default function UpdateProgressButton({
  goal
}: {
  goal: GoalSerializersGoalByline;
}) {
  const [updateGoalProgressQuery, { loading: updatingProgress }] = useMutation(
    updateProgress,
    {
      fetchPolicy: "no-cache",
      onCompleted: () => {
        router.reload();
      },
    }
  );

  const updateGoalProgress = () => {
    updateGoalProgressQuery({
      variables: {
        id: goal.id,
      },
    });
  };

  return (
    <Button
      variant="ghost"
      size="md"
      onClick={updateGoalProgress}
      isLoading={updatingProgress}
    >
      Update progress
    </Button>
  );
}
